import * as angular from 'angular';
import upp from 'app/app.module';

var defaultAddress = {
    addressee: '',
    street: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    nif: '',
}

InputAddressComponent.$inject = [ '$scope', '$attrs' ];
function InputAddressComponent($scope, $attrs) {
    /**
     * Local value emitter of the selected country.
     * @type {Rx.BehaviorSubject<string>}
     */
    var localAddress$ = new Rx.BehaviorSubject({});

    /**
     * Observable that emits every time the value passed via directive
     * attribute value changes.
     * @type {Rx.Observable<string>}
     */
    var address$ = new Rx.Observable(function(subscription) {
        var next = function(val) { subscription.next(angular.copy(val)) };
        if ($scope['value'])
            next($scope['value'])
        return $scope.$watch('value', next);
    }).filter(function(val) {
        return !angular.equals(val, localAddress$.getValue())
    }).map(function(val) {
        return Object.assign({}, defaultAddress, val);
    });

    /**
     * Returns the getter function for the value of field identified by
     * field name on the last emitted address
     */
    var address$FieldGetter = function(fieldName) {
        return function() {
            return localAddress$.getValue()[fieldName] || null;
        }
    }

    /**
     * Returns the setter function for the value of field identified by
     * field name on the last emitted address, which causes address$ to
     * emit a new value.
     */
    var address$FieldSetter = function(fieldName) {
        return function(value) {
            var update = {};
            update[fieldName] = value;
            localAddress$.next(Object.assign({}, localAddress$.getValue(), update));
        }
    }

    Object.defineProperties(this, {
        addressee: {
            get: address$FieldGetter('addressee'),
            set: address$FieldSetter('addressee'),
        },
        street: {
            get: address$FieldGetter('street'),
            set: address$FieldSetter('street'),
        },
        city: {
            get: address$FieldGetter('city'),
            set: address$FieldSetter('city'),
        },
        state: {
            get: address$FieldGetter('state'),
            set: address$FieldSetter('state'),
        },
        postalCode: {
            get: address$FieldGetter('postalCode'),
            set: address$FieldSetter('postalCode'),
        },
        country: {
            get: address$FieldGetter('country'),
            set: address$FieldSetter('country'),
        },
        nif: {
            get: address$FieldGetter('nif'),
            set: address$FieldSetter('nif'),
        },
        // Directive attributes
        useNif: { get: function() { return !!$scope['useNif'] } },
        onChange: { get: function() { return $scope['onChange'] || angular.noop } },
        // Input component attributes
        required: { get: function() { return !!$attrs['required'] } },
        readonly: { get: function() { return !!$attrs['readonly'] } },
        disabled: { get: function() { return !!$attrs['disabled'] } },
    });

    // Wire emisions and events
    // > Emit any address$ coming from the input attribute as a local value
    var subValues = address$.subscribe(function(val) { localAddress$.next(val) });
    // > Notify any localValue$ via callback
    var subNotifyChanges = localAddress$
        .subscribe(function(val) { this.onChange({ $event: val }) }.bind(this));
    // Unregister on destroy
    $scope.$on('$destroy', function() {
        subValues.unsubscribe();
        subNotifyChanges.unsubscribe();
    })
}

upp.directive('inputAddress', function () {
    return {
        restrict: 'E',
        scope: {
        	value: '=',
            onChange: '&?',
            useNif: '=',
        },
        templateUrl: require('./input-address.component.html'),
        styles: require('./input-address.component.less'),
        controllerAs: '$ctrl',
        controller: InputAddressComponent,
    };
});




// WEBPACK FOOTER //
// ./src/app/common/components/input-address/input-address.component.js